import React from "react";
import { ArrowRight } from "lucide-react";
import { useI18n } from "../i18n";
import { posts, postsForLocale } from "../blog/posts";
import BlogCard from "../blog/BlogCard";

export default function BlogGrid() {
  const { t, locale } = useI18n();
  const visiblePosts = postsForLocale(posts, locale);

  return (
    <section className="nfw-section">
      <span className="nfw-anchor" id="blog" />
      <div className="nfw-wrap">
        <div className="nfw-section-head">
          <div>
            <p className="nfw-kicker">{t.blog.kicker}</p>
            <h2 className="nfw-h2">{t.blog.title}</h2>
          </div>
          <p className="nfw-lead">{t.blog.subtitle}</p>
        </div>
        <div className="nfw-blog-grid">
          {visiblePosts.map((post) => (
            <BlogCard
              key={post.slug}
              post={post}
              locale={locale}
              readMore={t.blog.readMore}
            />
          ))}
        </div>
        <a className="nfw-blog-index-link" href="/blog">
          {t.blog.allPosts}
          <ArrowRight size={16} />
        </a>
      </div>
    </section>
  );
}
